import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private counter = 0;
  private readonly loadingSubject = new BehaviorSubject<boolean>(false);
  loading$ = this.loadingSubject.asObservable();

  start(): void {
    this.counter += 1;
    this.emit();
  }

  stop(): void {
    this.counter = Math.max(0, this.counter - 1);
    this.emit();
  }

  reset(): void {
    this.counter = 0;
    this.emit();
  }

  private emit(): void {
    this.loadingSubject.next(this.counter > 0);
  }
}
